import component from './zh-TW/component';
import globalHeader from './zh-TW/globalHeader';
import menu from './zh-TW/menu';
import pages from './zh-TW/pages';
import pwa from './zh-TW/pwa';
import settingDrawer from './zh-TW/settingDrawer';
import settings from './zh-TW/settings';

export default {
    'navBar.lang': '語言',
    'layout.user.link.help': '幫助',
    'layout.user.link.privacy': '隱私',
    'layout.user.link.terms': '條款',
    'app.preview.down.block': '下載此頁面到本地項目',
    ...pages,
    ...globalHeader,
    ...menu,
    ...settingDrawer,
    ...settings,
    ...pwa,
    ...component,
    // --- Api 對外接口相關 ---
    'api.error.INVALID_APP_KEY': '無效的 AppKey',
    'api.error.APP_KEY_REQUIRED': '請提供 AppKey',
    'api.error.USER_DISABLED': '您的帳號已被禁用，請聯繫客服',
    'api.error.INTERNAL_SERVER_ERROR': '伺服器內部錯誤，請稍後再試',
    'api.error.USER_FROZEN': '帳號已被凍結，請聯繫管理員',

    // --- 公共登錄相關 ---
    'api.error.CAPTCHA_INCORRECT': '驗證碼不正確',
    'api.error.CAPTCHA_GENERATE_FAILED': '驗證碼生成失敗',
    'api.error.LOGIN_PARAMS_ABNORMAL': '登錄參數異常',
    'api.error.TOKEN_VERIFY_FAILED': '登錄已過期，請重新登錄',
    'api.error.TOKEN_INVALID': '無效的身份令牌',
    'api.error.TOKEN_SIGNATURE_INVALID': '身份簽名校驗失敗',
    'api.error.TOKEN_MISSING': '未檢測到登錄狀態',
    'api.error.INVALID_CREDENTIALS': '用戶名或密碼錯誤',
    'api.error.TOKEN_GENERATION_FAILED': '登錄令牌生成失敗',

    // --- 帳戶狀態相關 ---
    'api.error.ACCOUNT_NAME_REQUIRED': '帳戶名不能为空',
    'api.error.BANK_CARD_NO_REQUIRED': '銀行卡號不能为空',
    'api.error.ACCOUNT_LIST_FETCH_FAILED': '查詢帳戶列表失敗',
    'api.error.INVALID_USER_ID': '無效的用戶 ID',
    'api.error.USER_NOT_FOUND': '未找到相關用戶信息',
    'api.error.USER_UPDATE_FAILED': '用戶信息更新失敗',
    'api.error.USER_CREATE_FAILED': '商戶信息創建失敗',
    'api.error.ACCOUNT_DISABLED': '該帳戶已被禁用',
    'api.error.ACCOUNT_LOCKED': '帳戶已被鎖定',
    'api.error.DELETE_USER_FAILED': '註銷帳戶失敗',
    'api.error.USER_HAS_REMAINING_BALANCE': '帳戶內仍有餘額，無法執行此操作',
    'api.error.USER_FETCH_FAILED': '獲取用戶信息失敗',

    // --- 提現與交易業務 ---
    'api.error.UNSUPPORTED_WITHDRAW_METHOD': '不支持的提現方式',
    'api.error.INVALID_WITHDRAW_AMOUNT': '提現金額必須大於 0',
    'api.error.INVALID_PAY_PASSWORD': '支付密碼錯誤',
    'api.error.PAY_PASSWORD_NOT_SET': '您尚未設置支付密碼',
    'api.error.WITHDRAW_STATUS_DENY': '當前帳戶狀態異常，無法發起提現',
    'api.error.INSUFFICIENT_BALANCE': '帳戶可用餘額不足',
    'api.error.CREATE_WITHDRAW_RECORD_FAILED': '創建提現記錄失敗',
    'api.error.UPDATE_USER_BALANCE_FAILED': '扣減帳戶餘額失敗',
    'api.error.WRITE_FUND_LOG_FAILED': '資金流水寫入失敗',

    // --- 統計與報表 ---
    'api.error.USER_DAILY_STATS_GET_TODAY_FAILED': '獲取今日統計數據失敗',
    'api.error.USER_DAILY_STATS_TODAY_DATA_NOT_FOUND': '今日暫無統計數據',
    'api.error.ORDER_LIST_QUERY_FAILED': '查詢訂單數據失敗',

    // --- 系統通知與公告 ---
    'api.error.UPDATE_NOTICE_FAILED': '更新閱讀狀態失敗',
    'api.error.NOTIFICATION_COUNT_FAILED': '統計通知總數失敗',
    'api.error.NOTIFICATION_QUERY_FAILED': '查詢通知列表失敗',

    // --- 商戶提現帳戶管理 ---
    'api.error.USERACCOUNT_NO': '提現帳戶不存在',
    'api.error.USERACCOUNT_CREATE_FAILED': '創建提現帳戶失敗',
    'api.error.USERACCOUNT_DELETE_FAILED': '刪除提現帳戶失敗',
    'api.error.USERACCOUNT_COUNT_FAILED': '統計提現帳戶數量失敗',
    'api.error.USERACCOUNT_QUERY_FAILED': '查詢提現帳戶列表失敗',
    'api.error.USERACCOUNT_UPDATE_FAILED': '修改提現帳戶失敗',
    'api.error.USERACCOUNT_PARAM_INVALID': '帳戶參數不合規',

    // --- 通用 ---
    'api.error.PARAMS_ABNORMAL': '請求參數異常',
};
